import { FlexGroup, FlexItem, Text } from '@antoree/ant-ui';
import { FormattedMessage } from 'react-intl';
import Td from './Td';

export type HeaderTestResultProps = {};
const YoungLearnerScore: React.FC<HeaderTestResultProps> = ({}) => {
  return (
    <FlexGroup>
      <FlexItem>
        <Text color="subdued">
          <span>Score for each criteria/ Điểm cho từng tiêu chí</span>
        </Text>
        <table className="table-fixed">
          <tbody>
            <tr>
              <Td>0</Td>
              <Td>1</Td>
              <Td>2</Td>
              <Td>3</Td>
            </tr>
            <tr>
              <Td>
                <strong>
                  <FormattedMessage defaultMessage="Not Applicable" />
                </strong>
              </Td>
              <Td>
                <strong>
                  <FormattedMessage defaultMessage="Basic" />
                </strong>
              </Td>
              <Td>
                <strong>
                  <FormattedMessage defaultMessage="Adaptable" />
                </strong>
              </Td>
              <Td>
                <strong>
                  <FormattedMessage defaultMessage="Perfect" />
                </strong>
              </Td>
            </tr>
          </tbody>
        </table>
        <Text color="subdued">
          <span>Total score and level/ Tổng điểm và trình độ</span>
        </Text>
        <table className="table-fixed">
          <tbody>
            <tr>
              <Td>0 - 5</Td>
              <Td>6 - 10</Td>
              <Td>11 - 15</Td>
              <Td>16 - 20</Td>
              <Td>21 - 25</Td>
              <Td>26 - 30</Td>
            </tr>
            <tr>
              <Td>
                <strong>
                  <FormattedMessage defaultMessage="Pre-A1" />
                </strong>
              </Td>
              <Td>
                <strong>
                  <FormattedMessage defaultMessage="Upper Pre-A1" />
                </strong>
              </Td>
              <Td>
                <strong>
                  <FormattedMessage defaultMessage="A1" />
                </strong>
              </Td>
              <Td>
                <strong>
                  <FormattedMessage defaultMessage="Upper A1" />
                </strong>
              </Td>
              <Td>
                <strong>
                  <FormattedMessage defaultMessage="A2" />
                </strong>
              </Td>
              <Td>
                <strong>
                  <FormattedMessage defaultMessage="Upper A2" />
                </strong>
              </Td>
            </tr>
          </tbody>
        </table>
      </FlexItem>
    </FlexGroup>
  );
};

export default YoungLearnerScore;
